<template>
  <svg width="13" height="20" viewBox="0 0 13 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.25 20C2.80334 20 0 17.1967 0 13.75V5C0 4.53918 0.373383 4.16672 0.833282 4.16672C1.29333 4.16672 1.66672 4.53918 1.66672 5V13.75C1.66672 16.2767 3.72253 18.3333 6.25 18.3333C8.77747 18.3333 10.8333 16.2767 10.8333 13.75V4.58328C10.8333 2.97501 9.52499 1.66672 7.91672 1.66672C6.30829 1.66672 5 2.97501 5 4.58328V12.9167C5 13.6058 5.56076 14.1667 6.25 14.1667C6.93924 14.1667 7.5 13.6058 7.5 12.9167V5C7.5 4.53918 7.87338 4.16672 8.33328 4.16672C8.79333 4.16672 9.16672 4.53918 9.16672 5V12.9167C9.16672 14.525 7.85828 15.8333 6.25 15.8333C4.64172 15.8333 3.33328 14.525 3.33328 12.9167V4.58328C3.33328 2.05673 5.3891 0 7.91672 0C10.4442 0 12.5 2.05673 12.5 4.58328V13.75C12.5 17.1967 9.69666 20 6.25 20Z" fill="currentColor" />
  </svg>
</template>

<script>
export default {
  name: 'Upload',
};
</script>
